<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-20 11:59:34
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-07-20 15:24:29
-->
<template>
	<div>
		<el-dialog title="查看失败原因" :visible.sync="dialogTableVisible" :before-close="handleClose" width="680px">
			<el-table
				:data="reasonList"
				style="width:100%"
				border
				max-height="480"
				header-row-class-name="table-header-row"
				row-class-name="table-row"
				v-loading="loading"
				element-loading-spinner="el-icon-loading"
			>
				<el-table-column prop="fail_reason" label="失败原因" width="360"></el-table-column>
				<el-table-column prop="name" label="达人信息" width="287">
					<template slot-scope="{ row }">
						<Talent-cell :row="row"></Talent-cell>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
import { getReasonList } from '@/api/talentCRM';
import TalentCell from './talentCell';
export default {
	data() {
		return {
			reasonList: [],
			dialogTableVisible: false,
			loading: false,
		};
	},
	props: {
		taskId: {
			tyep: Number,
			default: () => 0,
		},
	},
	components: {
		TalentCell,
	},
	methods: {
		async show() {
			this.dialogTableVisible = true;
			this.loading = true;
			const { list } = await getReasonList({ common_task_id: this.taskId - 0 });
			this.loading = false;
			this.reasonList = list;
		},

		handleClose(done) {
			done();
		},
	},
};
</script>

<style lang="less" scoped>
/deep/.el-table__body-wrapper {
	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: @border-color-lighter;
	}
}
</style>
